module.exports = __webpack_public_path__ + "static/media/user_mock.23e21496.jpg";